export enum MppSocialCredentialStatus {
  EXPIRED = 'expired',
  EXPIRING = 'expiring',
  ACTIVE = 'active',
  NOT_CONNECTED = 'not_connected',
}
